export function NotFound() {
	return (
		<div className='grid grow place-items-center'>
			<p className='text-neutral-400 dark:text-neutral-500'>Not found</p>
		</div>
	);
}
